import React from 'react';

var DripNoFound = function DripNoFound() {
  return /*#__PURE__*/React.createElement("img", {
    src: "//img13.360buyimg.com/imagetools/jfs/t1/219256/24/5/39764/61653af4E0a017bfd/942b39ce71533989.png",
    width: "252",
    height: "147",
    alt: "404"
  });
};

export default DripNoFound;